<template>
  <b-row>
    <b-col cols="12">
      <KarmaCatalogueAddForm />
    </b-col>
  </b-row>
</template>

<script>
import { BRow, BCol } from 'bootstrap-vue'
import KarmaCatalogueAddForm from './KarmaCatalogueAddForm.vue'

export default {
  components: {
    BRow,
    BCol,
    KarmaCatalogueAddForm,
  },
}
</script>

<style lang="scss">
    @import '@core/scss/vue/libs/vue-wizard.scss';
    @import '@core/scss/vue/libs/vue-select.scss';
</style>
